import {ApplicationConfig, LOCALE_ID} from "@angular/core";
import {registerLocaleData} from "@angular/common";
import localeDe from '@angular/common/locales/de';
import {ENDPOINT_URL_PROVIDER} from "../config/endpoint.config";
import {DEFAULT_HEADERS_PROVIDER} from "../config/authorization.config";
import {provideRouter} from "@angular/router";
import {APP_ROUTES, APP_ROUTING_PROVIDER} from "./app.routes";
import {SENTRY_ERRORHANDLING_PROVIDER} from "../config/sentry.config";
import {INTERCEPTOR_PROVIDERS} from "./interceptors.config";
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {provideMarkdown} from "ngx-markdown";

// following needed for extension methods:
import './_services/rxjs-extensions';
import './_services/date-extensions';
import './_services/number-extensions';
import './_services/string-extensions';
import './_services/http-response-extensions';

registerLocaleData(localeDe);

export const APP_CONFIG: ApplicationConfig = {
  providers: [
    ENDPOINT_URL_PROVIDER,
    DEFAULT_HEADERS_PROVIDER,
    ...INTERCEPTOR_PROVIDERS,
    provideRouter(APP_ROUTES),
    APP_ROUTING_PROVIDER,
    ...SENTRY_ERRORHANDLING_PROVIDER,
    {
      provide: LOCALE_ID,
      useValue: "de-DE"
    },
    provideHttpClient(withInterceptorsFromDi()),
    // ngx-markdown's `MarkdownService` is a plain `@Injectable()` — NOT `providedIn: 'root'` — and its
    // `SANITIZE` dependency is non-optional, so every `<markdown>` in the app needs something to provide it.
    // Nothing did: the changelog page has rendered `<markdown [data]="item.content">` since long before #501 and
    // threw `NullInjectorError: No provider for MarkdownService` the moment it was opened. Providing it once
    // here repairs that page and covers the form runtime's Markdown static text at the same time.
    // Left at the defaults on purpose: no loader (nothing fetches Markdown over HTTP) and `SANITIZE` at
    // `SecurityContext.HTML`, so converted Markdown is sanitised exactly like an `[innerHTML]` binding.
    provideMarkdown()
  ]
}

// `App` moved to ./app-injector so leaf model files can reach the injector WITHOUT importing this module —
// this one drags in app.routes (and with it every routed component), which closed an import cycle back onto
// those components. Re-exported here so existing importers keep working; new code imports from app-injector.
export {App} from './app-injector';
